module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_pastel.b04ce421.png";